import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TransactionsService } from '../transactions.service';
import { ViewIndividualPendingTransactionsResponseModel } from '../../model/viewIndividualPendingTransactionsResponseModel';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pending-transactions',
  templateUrl: './pending-transactions.component.html',
  styleUrls: ['./pending-transactions.component.css']
})
export class PendingTransactionsComponent implements OnInit, OnDestroy {
  
  title= "View Pending Transactions";

  viewIndividualPendingTransactions = new ViewIndividualPendingTransactionsResponseModel();
  individualPendingTransactionsSubscription: Subscription;
  constructor(private transactionsService: TransactionsService, private currentPageWatcherService: CurrentPageWatcherService,private router : Router) { 
    this.individualPendingTransactionsSubscription= this.transactionsService.notifyIndividualPendingTransactions
    .subscribe(viewIndivPendingTransactions =>{

      this.viewIndividualPendingTransactions=viewIndivPendingTransactions;
      console.log("viewIndividualPendingTransactions response model ", this.viewIndividualPendingTransactions);
    })
  }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit(this.title);

 
  }

  goBackHome(){
    this.router.navigate(['/home'])
  }
  ngOnDestroy(): void {
    this.individualPendingTransactionsSubscription.unsubscribe();
    this.currentPageWatcherService.clearUserMessage();
    this.currentPageWatcherService.clearStepMessage();
  }

}



// WEBPACK FOOTER //
// ./src/app/transactions/pending-transactions/pending-transactions.component.ts